/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Tr_KeduanyaInputs */

const en_cp_tr_keduanya = /** @type {(inputs: Cp_Tr_KeduanyaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both`)
};

const id_cp_tr_keduanya = /** @type {(inputs: Cp_Tr_KeduanyaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keduanya`)
};

/**
* | output |
* | --- |
* | "Both" |
*
* @param {Cp_Tr_KeduanyaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_tr_keduanya = /** @type {((inputs?: Cp_Tr_KeduanyaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Tr_KeduanyaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_tr_keduanya(inputs)
	return en_cp_tr_keduanya(inputs)
});